export default function transformUser(u) {
  return {
    userId: u.userId,
    nickname: u.nickname,
    profileUrl: u.profileUrl
  };
}
